import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Button } from '@termly-web/react-components'

import Styles from './styles.scss'


// We might want to move this into @termly-web/react-components, but for
// now I'm keeping it here so as not to bloat that package.

/**
 * A cleaner (than components/Button) implementation of a button with
 * an embedded loading spinner.
 */
export default function LoadingButton({ children, className, isLoading, ...props }) {
  const rootClassName = classnames(Styles.root, className)
  const contentClassName = classnames(Styles.content, {
    [Styles.loading]: isLoading,
  })

  return (
    <Button
      { ...props }
      className={ rootClassName }
    >
      <div className={ contentClassName }>
        { children }
      </div>
    </Button>
  )
}

LoadingButton.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  ...Button.propTypes,
}
